import React from 'react';
import { useTranslation } from 'react-i18next';

import { ShowMoreComponentProps } from '@common/components/list/async';
import Spinner from '@common/components/spinner';

// Should probably the default for AsyncList, but not sure if this will impact
// other places that currently use AsyncList
// See https://linear.app/oneteam/issue/ONE-1202/asynclist-load-more-default-component-is-wrong
const ListShowMoreComponent = ({ onShowMore, isFetching }: ShowMoreComponentProps) => {
  const { t } = useTranslation();

  return (
    <div className="Table__ShowMore" onClick={!isFetching ? onShowMore : undefined} role="button">
      {isFetching ? <Spinner centered /> : t('common:table_show_more')}
    </div>
  );

};

export default ListShowMoreComponent;
